import React, { useEffect, useState } from 'react';
import { Box, Center, FormLabel, HStack, Image, Stack, Text } from '@chakra-ui/react';
import { pillarCover } from '../../assets/new-images/icons';
import { carregarCapaDoPilar } from '../../core/imagens/capaDoPilar';

/**
 * A identidade do pilar — imagem de capa e texto — em SOMENTE LEITURA.
 *
 * POR QUE APARECE, E POR QUE NÃO É EDITÁVEL
 *   Pós-EG-40 imagem e texto são conteúdo do PILAR DO CATÁLOGO GLOBAL: o mesmo
 *   "Ambiental" é usado por vários clientes, e editá-lo a partir da tela de um
 *   questionário muda o conceito para todos. É a mesma família dos três botões
 *   que a AD-5 aposentou.
 *
 *   Mas esconder também estava errado — decisão do dev no teste exploratório:
 *   a informação é rica para quem monta o questionário, e ele precisa VER com que
 *   identidade aquele pilar vai aparecer para quem responde. Então mostra-se, sem
 *   permitir editar, e diz-se onde se edita.
 *
 *   É a mesma resposta que a EG-41 deu ao rótulo de classificação: exibir o que
 *   o catálogo diz, e mandar quem quer mudar para a tela do catálogo.
 */
export default function IdentidadeDoPilar({ imgPillar, textPillar }) {
  const [imageURL, setImageURL] = useState('');

  // A capa NÃO pode ser montada como URL da API direto no src.
  //
  // A primeira versão fazia `src={baseUrl + '/image/' + chave}`, e no ambiente
  // com autenticação isso deu **401**: requisição de tag <img> é do navegador,
  // não passa pelo interceptor do axios e não leva Bearer token. Na tela aparecia
  // ícone de imagem quebrada, e nada no console da aplicação — só no network.
  //
  // carregarCapaDoPilar busca pelo baseService e devolve object URL local. O
  // cleanup abaixo é obrigatório: object URL só sai da memória com revoke, e sem
  // ele cada troca de pilar deixa um blob preso na aba.
  useEffect(() => {
    let ativo = true;
    let urlLocal = null;

    carregarCapaDoPilar(imgPillar).then((url) => {
      // Se o componente desmontou ou o pilar mudou enquanto a busca corria, o
      // blob recém-criado não tem dono: revogar aqui evita o vazamento e evita
      // pintar a capa do pilar ANTERIOR sobre o atual.
      if (!ativo) {
        if (url) URL.revokeObjectURL(url);
        return;
      }
      urlLocal = url;
      setImageURL(url || '');
    });

    return () => {
      ativo = false;
      if (urlLocal) URL.revokeObjectURL(urlLocal);
    };
  }, [imgPillar]);

  return (
    <HStack spacing='6' align='start' p='6'>
      <Stack spacing='1' minW='232px'>
        <FormLabel fontSize='12px' mb='0' color='#292B30'>
          Imagem de capa
        </FormLabel>
        <Center
          h='151px'
          bg='#F0F0F0'
          borderRadius='8px'
          overflow='hidden'
          flexDirection='column'
        >
          {imageURL ? (
            <Image
              src={imageURL}
              alt='Imagem de capa do pilar'
              h='full'
              w='full'
              objectFit='cover'
            />
          ) : (
            <>
              <Image src={pillarCover} alt='' w='42px' opacity={0.6} />
              <Text fontSize='12px' color='#5C6066' mt='2'>
                Sem imagem
              </Text>
            </>
          )}
        </Center>
      </Stack>

      <Stack spacing='1' flex='1'>
        <FormLabel fontSize='12px' mb='0' color='#292B30'>
          Texto do pilar
        </FormLabel>
        <Box
          h='151px'
          bg='#F5F5FB'
          borderRadius='8px'
          p='4'
          overflowY='auto'
          fontSize='sm'
          color={textPillar ? '#292B30' : '#797D9A'}
        >
          {textPillar || 'Este pilar ainda não tem texto cadastrado.'}
        </Box>
        <Text fontSize='12px' color='#5C6066'>
          Imagem e texto são do catálogo de pilares e valem para todos os
          questionários. Para alterá-los, edite o pilar em Pilares.
        </Text>
      </Stack>
    </HStack>
  );
}
